import { CompanyService } from './../../../services/company.service';
import { ProfileService } from './../../../services/profile.service';
import { AuthService } from '../../../services/auth.service';
import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ToolbarModule } from 'primeng/toolbar';
import { DateUtilsService } from '../../../services/date-utils.service';
import { Profile } from '../../../shared/models/profile.model';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [ToolbarModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  dateUtil = inject(DateUtilsService);
  profileService = inject(ProfileService);
  companyService = inject(CompanyService);
  authService = inject(AuthService);
  companyName = environment.companyName;
  profile: Profile | null = null;
  currentYear = new Date().getFullYear();
  timeZone: string | null | undefined;

  get currentDate(): string {
    return this.dateUtil.formatWithTimezone(new Date());
  }

  ngOnInit(): void {
    if (!this.authService.isSuperAdmin()) {
      this.profileService.loadProfile().subscribe();
    }

    this.profileService.getTimeZoneOffset().subscribe({
      next: (timeZone) => {
        this.timeZone = timeZone;
      }
    });

    this.companyService.getSelectedCompany().subscribe({
      next: (company) => {
        if (company && !this.timeZone) {
          if (company.timeZone) {
            this.profileService.setTimeZoneOffset(company.timeZone);
          }
        }
      }
    });
  }
}
